import IconButton from '@mui/material/IconButton'
import { styled } from '@mui/material/styles'

export const IconButtonStyled = styled(IconButton, {
  name: 'IconButtonStyled',
})`
  background: rgba(0, 0, 0, 0.04);
  height: 45px;
  width: 45px;

  &:hover {
    background: #e4e6ea;
  }
`
